import React from "react";
import "./About.css";
import { motion } from "framer-motion";
import ScrollBar from "../shared/ScrollBar";
import LinkHome from "../shared/LinkHome";

const About = () => {
  return (
    <section className="about">
      <ScrollBar />
      <div className="aboutHead">
        <motion.div
          transition={{ duration: 0.2 }}
          animate={{ y: 0, opacity: 1 }}
          initial={{ y: 100, opacity: 0 }}
          className="headline"
        >
          <h2>I develop</h2>
          <h2>digital products</h2>
        </motion.div>

        <LinkHome color={"white"} />
      </div>

      <motion.div
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        viewport={{ once: true }}
        className="aboutContent"
      >
        <h2>About</h2>
        <p id="different">
          Hi, I'm Sadik, a multi-talented human with more than 3 years of
          development experience.
        </p>
        <p>
          You can also call me a product developer, front end developer, MERN
          stack developer, Mobile App developer (React-Native), traveler,
          photographer, instructor and more.
        </p>
        <p>
          I don't define myself by my work. My identity is determined by the
          work I want to do. Skills can be taught, but personality is inherent.
          As for me, I like to keep learning, keep challenging myself and pursue
          exciting projects that matter.
        </p>
        <p>
          I am passionate about learning, growing, and excelling in programming.
          I wake up every morning excited to be as productive every day as I
          can.
        </p>
        <p>
          Since beginning my journey as a Web Developer 3 years ago, I've done
          remote work for agencies, consulted for startups, and collaborated
          with talented people to create digital products for both business and
          consumer use.
        </p>
        <p>
          I'm quietly confident, naturally curious, and perpetually working on
          improving my chops one problem at a time.
        </p>
        <p>
          You can read more about my experience, skills and much more in the PDF
          attached below:
        </p>
        <a
          href="https://drive.google.com/file/d/1K6CGNGnkOJFB2Wafv4Ib7MBzUwEqzirm/view?usp=share_link"
          target="_blank"
          rel="noopener"
        >
          My resume (pdf 34kb)
        </a>
      </motion.div>
    </section>
  );
};

export default About;
